<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div >
  <div class="vx-row">
            

            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base mx-auto">
                <vx-card>
                    <img :src="data_local.image" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{data_local.titre}}</h5>
                        <p class="text-grey">{{data_local.description}}</p>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                        <span>
                            <p class="text-xl">{{data_local.prixx}} DT</p>
                            <p class="text-grey">prix</p>
                        </span>
                        <span>
                            <p class="text-xl">{{data_local.nom_domaine}}</p>
                            <p class="text-grey">Domaine</p>
                        </span>
                    </div>
                </vx-card>
            </div>
            

            
        </div>

                
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleformation from '@/store/formation/moduleformation.js'
import moment from 'moment'


//import axios from "../../../../http/axios/index.js"
//import users from "../../../../fake-db/data/user-management/index.js"
export default {
  components: {
    vSelect
  },
  
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      i:0,
      data_local: JSON.parse(JSON.stringify(this.data[0])),
     card_8: {},
      statusOptions: [
        { label: "Active",  value: "active" },
        { label: "Blocked",  value: "blocked" },
        { label: "Deactivated",  value: "deactivated" },
      ],
      roleOptions: [
        { label: "Admin",  value: "admin" },
        { label: "User",  value: "user" },
        { label: "Staff",  value: "staff" },
      ],
    }
  },
  computed: {
    
   /* status_local: {
      get() {
        console.log(this.data)
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set(obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set(obj) {
        this.data_local.role = obj.value
      }
    },*/
    validateForm() {
      return !this.errors.any()
    }
  },
  created() {
    
    // Register Module UserManagement Module
    if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
    console.log('data_local',this.data_local.id)
    this.$store.dispatch("formation/fetchFormateurs",this.data_local.id).catch(err => { console.error(err) })
    this.$store.dispatch("formation/fetchGroupes",this.data_local.id).catch(err => { console.error(err) })
    console.log('this.$store.state.formation.formateurs',this.$store.state.formation.formateurs.length)
    console.log('this.$store.state.formation.formateurs',this.$store.state.formation.formateurs[0])

    console.log(this.data_local)
    },
  methods: {
    
    formateur_data () {
       return this.$store.state.formation.formateurs
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
   confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.data_local.nom}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
      
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.$router.push({name:'app-user-list'});
      //this.showDeleteSuccess()
       
      /* UnComment below lines for enabling true flow if deleting user */
       this.$store.dispatch("formation/removeRecord", this.data_local.id)
         .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
         .catch(err => { console.error(err)       })
         
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    } 
    
  },
}
</script>
<style lang="scss">

@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
